import * as React from "react"
import type { SVGProps } from "react"
const SvgNoStatsFound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    {...props}
  >
    <path d="M2.63 14.03 1 12.85l5-8 3 3.5 4-6.5 3 4.5L19.38 1 21 2.17l-4.95 7.86-2.98-4.48-3.8 6.18L6.26 8.2zM14.5 18q1.06 0 1.77-.73.73-.72.73-1.77t-.73-1.78A2.4 2.4 0 0 0 14.5 13q-1.05 0-1.78.72A2.4 2.4 0 0 0 12 15.5q0 1.06.72 1.77.73.73 1.78.73m5.1 4-2.7-2.7q-.53.34-1.14.52a4.6 4.6 0 0 1-4.45-1.13A4.3 4.3 0 0 1 10 15.5q0-1.87 1.31-3.19A4.3 4.3 0 0 1 14.5 11q1.87 0 3.19 1.31a4.6 4.6 0 0 1 .61 5.59l2.7 2.7z" />
  </svg>
)
export default SvgNoStatsFound
